import { createAction, props } from '@ngrx/store';

import { Taxonomy } from '@core/models/taxonomy.model';

export const functionsNestedCollectionAddMany = createAction(
  '[STORED FUNCTIONS NESTED - ADD MANY] Functions Nested collection add many.',
  props<{ functionsNested: Taxonomy[] }>()
);
